import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function for combining CSS classes
 * 
 * Combines multiple class values using clsx and merges Tailwind CSS classes
 * using tailwind-merge to handle conflicts and duplicates properly.
 * 
 * @param inputs - Variable number of class values to combine
 * @returns string - Merged CSS class string
 * 
 * @example
 * ```typescript
 * const className = cn(
 *   'base-class',
 *   condition && 'conditional-class',
 *   'tailwind-class',
 *   { 'object-class': true }
 * );
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
} 